"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  altText: {
    id: "spinner.altText",
    defaultMessage: "Loading...",
    description: "Alternative text for Spinner if image can't be displayed"
  }
});

exports.default = _default;